if (!customElements.get('infinite-pagination')) {
	customElements.define('infinite-pagination', class InfinitePagination extends HTMLElement {
		constructor() {
			super();
			this.state = {
				isLoading: false,
				currentPage: parseInt(this.dataset.currentPage) || 1
			};

			this.selectors = {
				button: '.btn',
				productGrid: '[data-product-grid]',
				pagination: '[data-pagination]',
				productsContainer: '.collection-grid'
			};

			this.init();
		}

		init() {
			this.button = this.querySelector(this.selectors.button);
			this.nextPageUrl = this.dataset.nextPageUrl;
			this.section = this.dataset.section;

			if (this.button) {
				this.button.addEventListener('click', this.handleClick.bind(this));
			}
		}

		async handleClick(event) {
			event.preventDefault();
			if (this.state.isLoading) return;

			try {
				await this.loadProducts();
			} catch (error) {
				console.error('Failed to load more products:', error);
				this.showError();
			}
		}

		async loadProducts() {
			this.toggleLoading(true);

			const url = new URL(this.nextPageUrl, window.location.origin);
			url.searchParams.set('section_id', this.section);

			const response = await fetch(url.toString());

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			const html = await response.text();
			this.updateDOM(html);
			this.handlePostUpdate();
		}

		updateDOM(html) {
			const doc = new DOMParser().parseFromString(html, 'text/html');

			const elements = {
				fetchGrid: doc.querySelector(this.selectors.productGrid),
				fetchPagination: doc.querySelector(this.selectors.pagination),
				currentGrid: document.querySelector(this.selectors.productGrid),
				currentPagination: document.querySelector(this.selectors.pagination)
			};

			this.updateProducts(elements);
			this.updatePagination(elements);
		}

		updateProducts({ fetchGrid, currentGrid }) {
			if (!fetchGrid || !currentGrid) return;

			const fetchContainer = fetchGrid.querySelector(this.selectors.productsContainer);
			const currentContainer = currentGrid.querySelector(this.selectors.productsContainer);

			if (fetchContainer && currentContainer) {
				currentContainer.insertAdjacentHTML('beforeend', fetchContainer.innerHTML);
			}
		}

		updatePagination({ fetchPagination, currentPagination }) {
			if (fetchPagination && currentPagination) {
				currentPagination.outerHTML = fetchPagination.outerHTML;
			}
		}

		handlePostUpdate() {
			this.toggleLoading(false);

			if (window.lazyLoadEnabled === "true" && window.reloadLazyLoad) {
				window.reloadLazyLoad();
			}
			this.dispatchEvent(new CustomEvent('pagination:updated', {
				bubbles: true,
				detail: { currentPage: this.state.currentPage + 1 }
			}));
		}

		toggleLoading(isLoading) {
			this.state.isLoading = isLoading;
			this.button?.classList.toggle('loading', isLoading);
		}

		showError() {
			this.toggleLoading(false);
			this.button?.classList.add('error');
			setTimeout(() => {
				this.button?.classList.remove('error');
			}, 2000);
		}

		disconnectedCallback() {
			this.button?.removeEventListener('click', this.handleClick.bind(this));
		}
	});
}